import { render, staticRenderFns } from "./FaqMerchant.vue?vue&type=template&id=562bcfa9&"
import script from "./FaqMerchant.vue?vue&type=script&lang=js&"
export * from "./FaqMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports